var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:arrow-up"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1721 7.23265L3.20714 15.5922C3.07418 15.7316 3 15.9169 3 16.1097C3 16.3024 3.07418 16.4877 3.20714 16.6271L3.21614 16.6362C3.2806 16.704 3.35819 16.758 3.44419 16.795C3.53019 16.8319 3.6228 16.8509 3.71639 16.8509C3.80998 16.8509 3.90259 16.8319 3.98859 16.795C4.07459 16.758 4.15218 16.704 4.21664 16.6362L11.7166 8.76415L19.2136 16.6362C19.2781 16.704 19.3557 16.758 19.4417 16.795C19.5277 16.8319 19.6203 16.8509 19.7139 16.8509C19.8075 16.8509 19.9001 16.8319 19.9861 16.795C20.0721 16.758 20.1497 16.704 20.2141 16.6362L20.2231 16.6271C20.3561 16.4877 20.4303 16.3024 20.4303 16.1097C20.4303 15.9169 20.3561 15.7316 20.2231 15.5922L12.2581 7.23265C12.1881 7.15913 12.1039 7.1006 12.0105 7.06061C11.9172 7.02062 11.8167 7 11.7151 7C11.6136 7 11.5131 7.02062 11.4198 7.06061C11.3264 7.1006 11.2422 7.15913 11.1721 7.23265Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpArrowUp);
export default __webpack_public_path__ + "static/media/ep_arrow-up.c829e93d117f4a9651b3ce7ca7a3d0a7.svg";
export { ForwardRef as ReactComponent };